"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastType = void 0;
var ToastType;
(function (ToastType) {
    ToastType["Error"] = "error";
    ToastType["Info"] = "info";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
